import { arc, pie } from 'd3-shape';

import './Dashboard.css';

const height = 112;

const donutArc = arc()
  .outerRadius(height / 2)
  .innerRadius(height / 5);

const labelArc = arc()
  .outerRadius(height / 2.9)
  .innerRadius(height / 2.9);

const pieCreator = pie()
  .value(d => d.amount).sortValues(null);

function percentFormat(value) {
  if (isNaN(value)) {
    return '?';
  }
  return `${Math.round(value * 100)}%`;
}

function unitFormat(value) {
  if (isNaN(value)) {
    return '-';
  }
  return value.toFixed(1);
}

function InsulinDistribution(props) {
  const {
    dailyDeviations,
    dailyMeans,
    t,
  } = props;

  const pieParams = pieCreator(['bolus', 'basal'].map(insulin => ({
    name: insulin,
    amount: dailyMeans[insulin],
  })));

  return (
    <svg className="insulinDistribution" viewBox="0 0 285 118" preserveAspectRatio="xMidYMin slice" shapeRendering="auto">
      <g className="insulinDonut" transform="translate(60, 60)">
        {
          pieParams.map((p) => {
            const labelPosition = labelArc.centroid(p);
            return (
              <g key={p.data.name} className={`${p.data.name} arc`}>
                <path d={donutArc(p)} />
                <text
                  transform={`translate(${labelPosition[0]},${labelPosition[1]})`}
                >
                  {percentFormat(p.value / dailyMeans.total)}
                </text>
              </g>
            );
          })
        }
      </g>
      <g className="labels" transform="translate(130,0)">
        {['basal', 'bolus', 'total'].map((d, i) => (
          <g key={d} className={`${d} label`} transform={`translate(0,${(60 - 24) + (i * 24)})`}>
            <rect className={`${d} legend background`} width="145" height="20" rx="2" />
            <rect className={`${d} value background`} x="65" y="1" width="75" height="18" />
            <text dx="6" dy="16">{t(`insulin.distribution.${d}`)}</text>
            <g className="stats" transform="translate(117,0)">
              <text dx="-3" dy="16" className="value">{isNaN(dailyMeans[d]) ? '' : unitFormat(dailyMeans[d])}</text>
              <text dy="10" className="deviation">{isNaN(dailyDeviations[d]) ? '' : `±${unitFormat(dailyDeviations[d])}`}</text>
              <text dy="16" className="unit">{t('insulin.iu/d')}</text>
            </g>
          </g>
        ))}
      </g>
    </svg>
  );
}

export default InsulinDistribution;
